import { Editor } from "primereact/editor"
import styles from "../../../styles/Participant-Employment.module.css"

export default function EditorField(props) {
  const renderHeader = () => {
    return (
      <>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-underline" aria-label="Underline"></button>
          <button className="ql-strike" aria-label="Strike"></button>
          <button className="ql-link" aria-label="Link"></button>
        </span>
        <span className="ql-formats">
          <button
            type="button"
            className="ql-list"
            value="ordered"
            aria-label="Ordered List"
          ></button>
          <button
            type="button"
            className="ql-list"
            value="bullet"
            aria-label="Unordered List"
          ></button>
        </span>
      </>
    )
  }
  const header = renderHeader()
  return (
    <div className={styles.field}>
      {props.label != null ? (
        <label className={styles.label}>{props.label}</label>
      ) : (
        ""
      )}
      {props.subLabel != null ? (
        <label className={styles.sub_label}>{props.subLabel}</label>
      ) : (
        ""
      )}
      <Editor
        placeholder={props.placeholder ? props.placeholder : ""}
        value={props.value}
        onTextChange={(e) => {
          //Prevent user from adding unwanted attributes by copy/pasting
          const anyUnwantedAttr = e.delta.ops.some((item) => {
            if (item.hasOwnProperty("attributes")) {
              return Object.getOwnPropertyNames(item.attributes).some(
                (p) =>
                  p !== "bold" &&
                  p !== "italic" &&
                  p !== "underline" &&
                  p !== "strike" &&
                  p !== "link" &&
                  p !== "list"
              )
            }
            return false
          })
          if (!anyUnwantedAttr) {
            return props.valueName
              ? props.onTextChange(props.valueName, e.htmlValue)
              : props.onTextChange(e.htmlValue)
          } else {
            //If unwanted attributes are found return the original value to prevent the change
            return props.valueName
              ? props.onTextChange(props.valueName, props.value + " ")
              : props.onTextChange(props.value + " ")
          }
        }}
        headerTemplate={header}
        readOnly={props.disabled}
        className={`${styles.editor_field} custom_editor`}
        style={{ height: "140px" }}
      />
    </div>
  )
}
